import {GenericList} from './GenericList';
import {Notification} from '../../models/Notification';

export class NotificationList extends GenericList<Notification> {}
